export const BASENAME = ''; // don't add '/' at end off BASENAME for breadcrumbs 
//export const BASE_URL = '/app/dashboard/analytics';
export const BASE_URL = '/hospital';
export const BASE_TITLE = ' | CK Doctor';

export const TABLET_MIN_WIDTH = 996

export const CONFIG = {
    isInitTheme: true,
    layout: 'vertical', // vertical, horizontal
    subLayout: '', // horizontal-2
    collapseMenu: false, // mini-menu
    layoutType: 'menu-light', // menu-dark, menu-light, dark
    headerBackColor: 'header-blue', // header-blue, header-red, header-purple, header-info, header-green header-dark
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true,
    boxLayout: false,
    jwt: {
        secret: 'SECRET-KEY',
        timeout: '1 days'
    },
    firebaseOrigin: {
        apiKey: "AIzaSyC9m6rMXs8PKHkJaT761AupFQdmcjQDwSY",
        authDomain: "gradient-able-react-hook.firebaseapp.com",
        projectId: "gradient-able-react-hook",
        storageBucket: "gradient-able-react-hook.appspot.com",
        messagingSenderId: "787384589233",
        appId: "1:787384589233:web:2b57c391ac41d2d1967b90",
        measurementId: "G-1D6ER7YWLL"
    },
    firebase : {
        apiKey: "AIzaSyAdloEAyLCW2UKaGQ3fGpQ75fW0ZNg-YQI",
        authDomain: "ck-doctor.firebaseapp.com",
        projectId: "ck-doctor",
        storageBucket: "ck-doctor.appspot.com",
        messagingSenderId: "204180716759",
        appId: "1:204180716759:web:8a48df4137f6d0e58ec492"
    },
    auth0: {
        client_id: 'CkaKvwheIhIQkybjTEQwN7ikcdHObsPh',
        domain: 'dev-w0-vxep3.us.auth0.com'
    }
};
